module.exports = __webpack_public_path__ + "static/media/towtruck_welcome.06259fcf.svg";